import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTradingViewSteps: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTradingViewSteps"><Path fillRule="evenodd" clipRule="evenodd" d="M10 3V13H8.5V3H10ZM4.5 7V17H3V7H4.5ZM21 7V17H19.5V7H21ZM15.5 11V21H14V11H15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTradingViewSteps;
